/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';

export const barredLocationSchema = z.object({
  addressCountry: z.string().nullish(),
  addressState: z.string().nullish(),
  createdAt: z.string().datetime().nullish(),
  id: z.string().uuid(),
  name: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type BarredLocation = z.infer<typeof barredLocationSchema>;
